import React from 'react';
import { Navigate } from 'react-router-dom';
import { useRestaurant } from '../contexts/RestaurantContext';

export default function ProtectedRoute({ children, roles, requiredModule }) {
  const token = sessionStorage.getItem('casapizza_token');
  const user = (() => {
    const raw = sessionStorage.getItem('casapizza_user');
    return raw ? JSON.parse(raw) : null;
  })();
  const { restaurant } = useRestaurant();

  if (!token || !user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" replace />;
  if (requiredModule && restaurant && !restaurant.modules.includes(requiredModule)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
